import { BinaryOperatorEnum } from './binary-operator.enum';
import { FieldValueOperatorEnum } from './field-value-operator.enum';
import { FieldTypeEnum } from './field-type.enum';

// Represents a search expression that can be part of a list of expressions
// ex: "profileid" contains "15"
// note: this will be depreciated when we move to binary search expressions
export class SerialSearchExpression {
  public Field: string;
  public Value: string;
  public Value2: string; // ternary operator
  public FieldValueOperator: FieldValueOperatorEnum;
  public BinaryOperator: BinaryOperatorEnum;

  /**
   * used internally. not usedb by the server
   */
  public FieldType: FieldTypeEnum;

  public constructor() {
    this.Field = '';
    this.Value = '';
    this.FieldValueOperator = FieldValueOperatorEnum.Equals;
    this.BinaryOperator = BinaryOperatorEnum.And;
  }
}
